module.exports = __webpack_public_path__ + "static/media/autokar3 (11).d9470c44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar3 (11).jpg
// module id = 857
// module chunks = 0